export default __webpack_public_path__ + "static/media/tea.dac62019.png";